<template>
    <div class="borderComp">
        <div :style="{
            'border-image-source': `url('${configImgUrl()}${config.borImg}')`,
            'border-width': `${config.width}px`,
            'border-image-slice': '100',
            'border-style': 'solid'
        }"></div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/26 3:57 下午
     */

    export default {
        name: 'borderComp',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {},
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .borderComp {
        > div {
            width: 100%;
            height: 100%;
        }
    }
</style>
